import { Group, Pagination, Select, Text } from '@mantine/core';
import { useTranslation } from '../i18n/LocaleContext';

export const PAGE_SIZES = [25, 50, 100] as const;

/**
 * Numbered pagination for the list pages (rendered above AND below the
 * table): "N rows · page x of y", the page numbers, and a rows-per-page
 * picker. Backed by the list endpoints' OFFSET mode (`page` + `total`).
 */
export function ListPagination({
  page,
  pageCount,
  total,
  limit,
  loading,
  onPageChange,
  onLimitChange,
}: {
  page: number;
  pageCount: number;
  total: number;
  limit: number;
  loading?: boolean;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <Group gap="md" wrap="wrap" align="center">
      <Text size="xs" c="dimmed">
        {t('pagination.summary', {
          total: total.toLocaleString('id-ID'),
          page: Math.min(page, pageCount),
          pages: pageCount,
        })}
      </Text>
      <Pagination
        size="sm"
        value={Math.min(page, pageCount)}
        total={pageCount}
        onChange={onPageChange}
        siblings={1}
        boundaries={1}
        disabled={loading}
        withEdges
      />
      <Select
        size="xs"
        w={120}
        data={PAGE_SIZES.map((n) => ({ value: String(n), label: `${n} ${t('pagination.perPage')}` }))}
        value={String(limit)}
        onChange={(v) => {
          if (v) onLimitChange(Number(v));
        }}
        allowDeselect={false}
        aria-label={t('pagination.perPage')}
      />
    </Group>
  );
}
